const initialTopicState = {
    bucket: { },
    datatrack: 1
}
const TopicBucket = (state = initialTopicState , action) => {
    switch(action.type){
        case "SET_TOPIC_DATA":
            return {
                ...state,
                bucket: action.payload,
                datatrack: 0
            }
        default:
            return state
    }
}

export default TopicBucket;